import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-spinner-component',
  templateUrl: './loading-spinner-component.component.html',
  styleUrl: './loading-spinner-component.component.css',
  standalone: false
})
export class LoadingSpinnerComponentComponent {
  @Input() src: string = 'assets/spinner.png';
  @Input() texto: string = '';
}
